import {
  FormControl as ChakraFormControl,
  Flex,
  FormControlOptions,
  FormErrorMessage,
  FormLabel,
} from '@chakra-ui/react'
import styled from '@emotion/styled'

import { DatePicker } from '../DatePicker'
import { TimePicker } from '../DatePicker/TimePicker'

export const StyledFormInputControl = styled(ChakraFormControl)`
  .chakra-form__label {
    opacity: 1;
    color: #1a202c;
    font-size: 16px;
  }
`

export interface FormDatePickerControlIProps extends FormControlOptions {
  label?: string
  id?: string
  type?: string
  valid?: boolean
  errorMessage?: string
  leftIcon?: React.ElementType
  isDisabled?: boolean
  isAllDay?: boolean
  isInvalid?: boolean
  showStartTimePicker?: boolean
  showEndTimePicker?: boolean
  selectedDate: Date
  selectedEndTime?: Date
  onChangeDate?: (date: Date) => void
  onChangeStartTime?: (time: Date) => void
  onChangeEndTime?: (time: Date) => void
  [key: string]: unknown
}

export const FormDatePickerControl = ({
  id,
  label,
  isInvalid = false,
  isDisabled = false,
  isAllDay = false,
  errorMessage,
  showStartTimePicker,
  showEndTimePicker,
  selectedDate,
  selectedEndTime,
  onChangeDate,
  onChangeStartTime,
  onChangeEndTime,
  ...rest
}: FormDatePickerControlIProps) => {
  const shouldShowStartTimePicker = showStartTimePicker && !isAllDay
  const shouldShowEndTimePicker = showEndTimePicker && !isAllDay

  return (
    <StyledFormInputControl id={id} isInvalid={isInvalid}>
      <FormLabel htmlFor={id} mr='0'>
        {label}
      </FormLabel>
      <Flex>
        <Flex direction='column' mr='20px' width='calc(50% + 20px)'>
          <FormLabel mr='0'>Start Date</FormLabel>
          <DatePicker
            date={selectedDate}
            isDisabled={isDisabled}
            name={id}
            onChange={onChangeDate}
            {...rest}
          />
        </Flex>
        {shouldShowStartTimePicker && (
          <Flex direction='column' flex={1} mr='20px'>
            <FormLabel mr='0'> Start Time</FormLabel>
            <StyledFormInputControl id={id} isInvalid={isInvalid}>
              <TimePicker
                isDisabled={isDisabled}
                onChange={onChangeStartTime || onChangeDate}
                time={selectedDate}
                {...rest}
              />
            </StyledFormInputControl>
          </Flex>
        )}
        {shouldShowEndTimePicker && (
          <Flex direction='column' flex={1}>
            <FormLabel mr='0'> End Time</FormLabel>
            <StyledFormInputControl id={id} isInvalid={isInvalid}>
              <TimePicker
                isDisabled={isDisabled}
                onChange={onChangeEndTime}
                time={selectedEndTime}
                {...rest}
              />
            </StyledFormInputControl>
          </Flex>
        )}
      </Flex>
      <FormErrorMessage>{errorMessage}</FormErrorMessage>
    </StyledFormInputControl>
  )
}
